module.exports = __webpack_public_path__ + "img/media (6).bcb875d3.png";